import { Link } from 'react-router-dom'
import { PageHeader } from '@/components/layout/PageHeader'
import { useDocumentTitle } from '@/hooks/useDocumentTitle'
import pageStyles from './Page.module.css'

export function NotFoundPage() {
  useDocumentTitle('Page not found')

  return (
    <div className={pageStyles.page}>
      <PageHeader
        eyebrow="404"
        title="Page not found"
        lede="That address doesn't lead anywhere on this site."
      />
      <p>
        <Link to="/">Back to the home page</Link> or{' '}
        <Link to="/projects">browse the projects</Link>.
      </p>
    </div>
  )
}
